var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.725,
    height: 21.775,
    viewBox: "0 0 21.725 21.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_94214",
    "data-name": "Path 94214",
    d: "M18.435,15.676,16.618,16.7a1.146,1.146,0,0,1-1.373-.189L9.181,10.447a1.147,1.147,0,0,1-.189-1.373l1.024-1.817A1.719,1.719,0,0,0,9.733,5.2L7.01,2.474a1.719,1.719,0,0,0-2.431,0L3.342,3.71a4.585,4.585,0,0,0-.689,5.6l.62,1.034A35.939,35.939,0,0,0,16.261,23.058l.123.07a4.593,4.593,0,0,0,5.546-.722l1.291-1.291a1.719,1.719,0,0,0,0-2.431L20.5,15.959a1.719,1.719,0,0,0-2.06-.283Z",
    transform: "translate(-2 -1.971)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f5b56e8946dd1267f2c5d79dd2a95cfb.svg";
export { ForwardRef as ReactComponent };